import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useHandleError } from "@/hooks/useHandleError";
import { useAuthStore } from "@/store/auth.store";
import { useUsedReferral } from "@roman/shared/hooks/useUsedReferral";
import { useState } from "react";
import { ReferralSuccessModal } from "../Referral/Register/ReferralSuccessModal";

export const NewUserModals = ({
  setIsNewUser,
  userFreePoints,
}: {
  setIsNewUser: (value: boolean) => void;
  userFreePoints: string;
}) => {
  const handleReferralError = useHandleError("招待コードの履歴取得に失敗しました");
  const { data: usedReferral } = useUsedReferral(handleReferralError);
  const [newUserModalOpen, setNewUserModalOpen] = useState(true);
  const [referralModalOpen, setReferralModalOpen] = useState(false);
  const fetchUser = useAuthStore((state) => state.fetchAndSetUser);

  const handleOpenChange = (value: boolean) => {
    setNewUserModalOpen(value);
    setIsNewUser(value);

    if (usedReferral) {
      setReferralModalOpen(true);
    }
  };

  return (
    <>
      <Dialog open={newUserModalOpen} onOpenChange={handleOpenChange}>
        <DialogContent className="[&>button]:hidden py-12 w-[350px] md:w-[450px] h-[351px] ring-0 ring-transparent">
          <DialogTitle className="dialog-content text-black text-center font-Inter text-xl font-semibold leading-[30px] max-w-[287px] mx-auto">
            <p>ポイントが獲得されました！</p>
          </DialogTitle>

          <div className="flex justify-center mt-[20px]">
            <div className="inline-flex flex-row justify-center items-center p-[7px] px-[14px] gap-[10px] bg-[#ECECEC] h-[44px] rounded-[60px]">
              <div className="font-semibold text-[16px] leading-[35px] text-[#5C5C5C] flex items-center">
                <img src="/assets/pointicon.svg" alt="points coin icon" className="mr-2" />
                <div className="font-bold text-[18px] leading-[100%] text-black">{userFreePoints}pt</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col w-full items-center justify-center mt-5">
            <Button
              className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
              variant="default"
              onClick={() => handleOpenChange(false)}
            >
              確認
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <ReferralSuccessModal
        open={referralModalOpen}
        setOpen={(open) => {
          if (!open) {
            fetchUser();
          }
          setReferralModalOpen(open);
        }}
        earnedPoints={Number(usedReferral?.earnedPoints)}
      />
    </>
  );
};
